import React from 'react'
import { useI18n } from '../../hooks/useI18n'
import { useCare } from '../../hooks/useCare'
import ActivityHistory from '../calendar/ActivityHistory'
import ProgressKpis from '../progress/ProgressKpis'
import { usePersistedState } from '../../hooks/usePersistedState'

const ProgressPage: React.FC = () => {
  const { t } = useI18n()
  const { currentCase } = useCare()
  
  // Persistir filtros del historial
  const namespace = currentCase?.id || 'default'
  const [selectedMonth, setSelectedMonth] = usePersistedState<number>(
    'selectedMonth',
    new Date().getMonth(),
    namespace
  )
  const [selectedYear, setSelectedYear] = usePersistedState<number>(
    'selectedYear',
    new Date().getFullYear(),
    namespace
  )
  const [filter, setFilter] = usePersistedState<'all' | 'taken' | 'missed' | 'stock_adjusted'>(
    'filter',
    'all',
    namespace
  )
  const [groupByDate, setGroupByDate] = usePersistedState<boolean>(
    'groupByDate',
    true,
    namespace
  )
  const [searchText, setSearchText] = usePersistedState<string>(
    'searchText',
    '',
    namespace
  )

  if (!currentCase) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="text-6xl mb-4">📊</div>
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
            {t('no-case-selected')}
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            {t('select-case-progress')}
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <div className="bg-white dark:bg-gray-800 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="py-6">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                  {t('progress')}
                </h1>
                <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
                  Datos y estadísticas de tomas - {currentCase.name}
                </p>
              </div>
              <div className="flex items-center space-x-2">
                <div className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400">
                  <span>{currentCase.profileType === 'human' ? '👤' : '🐾'}</span>
                  <span>{currentCase.profileInfo?.name}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 lg:py-8 space-y-6">
        {/* KPIs Section */}
        <ProgressKpis selectedMonth={selectedMonth} selectedYear={selectedYear} />

        {/* Raw Data Section */}
        <ActivityHistory
          selectedDate={null}
          showDateFilter={true}
          selectedMonth={selectedMonth}
          selectedYear={selectedYear}
          filter={filter}
          groupByDate={groupByDate}
          searchText={searchText}
          onMonthChange={setSelectedMonth}
          onYearChange={setSelectedYear}
          onFilterChange={setFilter}
          onGroupByDateChange={setGroupByDate}
          onSearchTextChange={setSearchText}
        />
      </div>
    </div>
  )
}

export default ProgressPage